<template>
  <el-autocomplete
    :value="value"
    :fetch-suggestions="getUenRemote"
    :loading="uenLoading"
    v-bind="$attrs"
    v-on="listeners"
    @select="handleUenSelect"
    @blur="handleUenBlur"
    @focus="handleUenFocus"
    clearable
  ></el-autocomplete>
</template>

<script>
export default {
  name: "UenAutocomplete",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uenLoading: false,
      uenList: [],
      uenTimeout: null,
    };
  },
  computed: {
    listeners() {
      // 排除已被内部显式处理的事件，透传其余事件
      const { select, blur, focus, input, ...others } = this.$listeners;
      return {
        ...others,
        input: val => this.$emit("input", val),
      };
    },
  },
  methods: {
    // 场景一：获取焦点时立即请求
    handleUenFocus(event) {
      // 透传原生 focus 事件给父组件（如果有需要）
      this.$emit("focus", event);

      // 获取当前输入框的值（去除前后空格）
      const currentQuery = this.value ? this.value.trim() : "";

      // 清除可能存在的防抖定时器，直接、立即执行网络请求
      if (this.uenTimeout) clearTimeout(this.uenTimeout);

      // 注意：这里不需要传入 callback，因为组件在 focus 时会自动触发一次默认的 fetch-suggestions。
      // 我们直接执行请求，清洗完数据后更新 this.uenList，el-autocomplete 内部会响应式感知到数据。
      this.executeFetchUen(currentQuery, () => {});
    },

    // 场景二：用户点击下拉菜单选中
    handleUenSelect(item) {
      this.$emit("input", item.uen || "");
      this.$emit("change-company", item.companyName || "");
    },

    // 场景三：用户手动输入后失焦（忽略大小写匹配）
    handleUenBlur(event) {
      this.$emit("blur", event);

      const currentUen = this.value ? this.value.trim() : "";

      if (!currentUen) {
        this.$emit("change-company", "");
        return;
      }

      const searchKey = currentUen.toUpperCase();

      const matchedItem = this.uenList.find(ele => {
        return ele.uen && ele.uen.toString().toUpperCase() === searchKey;
      });

      if (matchedItem) {
        this.$emit("input", matchedItem.uen); // 规范化输入框文本为接口的大小写
        this.$emit("change-company", matchedItem.companyName || "");
      } else {
        this.$emit("change-company", "");
      }
    },

    // 远程搜索入口（打字时防抖）
    getUenRemote(query, callback) {
      if (this.uenTimeout) clearTimeout(this.uenTimeout);

      const trimmedQuery = query ? query.trim() : "";

      // 防抖：300毫秒后执行
      this.uenTimeout = setTimeout(() => {
        this.executeFetchUen(trimmedQuery, callback);
      }, 300);
    },

    // 核心接口请求方法
    executeFetchUen(query, callback) {
      this.uenLoading = true;
      this.$http
        .get("/admin/uenMa/getList", { params: { uen: query } })
        .then(res => {
          const resData = res.data || [];
          const formattedList = resData
            .filter(ele => ele?.uen)
            .map(ele => ({
              ...ele,
              value: ele.uen,
            }));

          // 完美兼容 n/a, N/a 各种情况
          if ("N/A".includes(query.toUpperCase())) {
            formattedList.unshift({
              companyName: "N/A",
              uen: "N/A",
              value: "N/A",
            });
          }

          this.uenList = formattedList;
          // 执行回调，渲染下拉框（如果是 focus 触发，此处的 callback 为空函数，不影响页面渲染）
          if (typeof callback === "function") {
            callback(formattedList);
          }
        })
        .catch(err => {
          console.error(err);
          this.uenList = [];
          if (typeof callback === "function") {
            callback([]);
          }
        })
        .finally(() => {
          this.uenLoading = false;
        });
    },
  },
};
</script>
